import React, { useEffect, useState } from 'react'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import CustomImage from '../../customImage/customImage'
import SectionalComponentArrowXL from '../imgComponents/sectionalComponentArrowXL'

const SectionalWithAdSection = ({
  componentData,
  setModalState,
  isEdit = true,
  theme,
  onAdd,
  pageURL = '',
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [activeTab, setActiveTab] = useState(0)

  const {
    customNavigate,
    CONTENT_FILTER_XAVIER,
    getTemplateImage,
    convertDuration,
    getReleaseDate,
    PortraitDummyImg,
    EditIcon,
  } = useTemplateHook()
  const [allContentData, setAllContentData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(async () => {
    setAllContentData([])
  }, [pageURL])

  const getDynamicFilters = (autoPayload) => {
    let obj = {}

    let ownersObj = autoPayload.find((info) => info.type === 'owners')

    if (ownersObj) {
      obj['owners'] = ownersObj?.values
    }

    return obj
  }

  useEffect(async () => {
    if (!isEmpty(data?.tab_section)) {
      let tempAllContent = []
      for (let i = 0; i < data?.tab_section.length; i++) {
        const element = data?.tab_section[i]

        let filterPayload =
          element?.type === 'STATIC'
            ? { content_ids: element?.content_data }
            : {
                system_defined: element?.auto_payload.filter(
                  (info) => info.type === 'system_defined',
                ),
                custom_defined: element?.auto_payload.filter(
                  (info) => info.type === 'custom_defined',
                ),
                video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
                ...getDynamicFilters(element?.auto_payload),
              }

        if (!isEmpty(element?.content_data) || !isEmpty(element?.auto_payload)) {
          let response = await contentListCall({
            data: {
              filters: filterPayload,
              page: 1,
              order_by:
                element?.type === 'STATIC'
                  ? ''
                  : element?.order_by === 'title'
                  ? `title.${language}`
                  : element?.order_by,
              reverse: element?.type === 'STATIC' ? '' : element?.reverse,
              page_size: 25,
            },
          })

          if (response && response.data.success) {
            let contentObj = response.data.data
            if (element.type === 'STATIC') {
              contentObj.sort((a, b) => {
                let sortingArr = element.content_data
                return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
              })
            }
            tempAllContent.push(contentObj)
          } else {
            tempAllContent.push([])
          }
        }
        setAllContentData([...tempAllContent])
      }
    } else {
      setAllContentData([])
    }
  }, [data])

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const handleCategoryClick = (id) => {
    customNavigate('DIRECT', `/metadata/${id}`)
  }

  const handleContentClick = (id) => {
    customNavigate('DIRECT', `/athlete/${pageURL}?content_id=${id}`)
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative py-[16px] lg:py-8 `}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <div
          className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-4 right-4 z-10 flex justify-center items-center cursor-pointer"
          onClick={() => handleModal()}
        >
          <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
        </div>
      )}

      <div
        className="w-full flex justify-center items-center"
        style={{
          paddingLeft: '3.66032%',
          paddingRight: '3.66032%',
        }}
      >
        <div className="w-full  flex flex-col xl:flex-row xl:justify-between">
          <div
            style={{
              borderTop: `1.5px solid ${getStyleValue(
                'component_background',
                'line_color',
                '#fc0001',
              )}`,
            }}
            className="w-full xl:w-[68.654%] max-h-[147.179vw] md:max-h-[100vw] xl:max-h-[89.3489vw] overflow-hidden"
          >
            <div
              className="mt-4 xl:mt-10 flex justify-start hidden-scrollbar-horizontal"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
              }}
            >
              {!isEmpty(data.tab_section) &&
                [...data.tab_section].map((info, index) => {
                  return (
                    <div
                      className="flex justify-center items-center w-max h-5 md:h-[35px] pb-1 xl:h-[40px] 2xl:h-[50px] relative cursor-pointer"
                      onClick={() => setActiveTab(index)}
                      key={index}
                    >
                      <SectionalComponentArrowXL
                        color={
                          activeTab === index
                            ? getStyleValue('content_section', 'tab_bg_active', '#fc0001')
                            : getStyleValue('content_section', 'tab_bg_inactive', '#fefefe')
                        }
                        imgStyle={{ height: '100%' }}
                      />
                      <p
                        style={{
                          color:
                            activeTab === index
                              ? getStyleValue('content_section', 'tab_text_active', '#ffffff')
                              : getStyleValue('content_section', 'tab_text_inactive', '#000000'),
                        }}
                        className="absolute text-sm xl:text-base mb-0 font-semibold"
                      >
                        {info.name}
                      </p>
                    </div>
                  )
                })}
            </div>
            <div className=" w-full h-[calc(100%-48px)] md:h-[calc(100%-63px)] xl:h-[calc(100%-104px)] 2xl:h-[calc(100%-114px)]  hidden-scrollbar-class overflow-hidden mt-3 xl:mt-6">
              {!isEmpty(allContentData[activeTab])
                ? allContentData[activeTab].map((item, index) => {
                    return (
                      <div
                        className={`flex justify-between w-full items-center ${
                          index && 'mt-4 xl:mt-6'
                        } `}
                        key={index}
                      >
                        <CustomImage
                          imageUrl={getTemplateImage(item?.portrait)}
                          imgClass="aspect-[280/380] w-[23.85%] cursor-pointer"
                          loaderClass="aspect-[280/380] w-[23.85%]"
                          loaderStyle={{ background: '#5A5A5A50' }}
                          imgAlt={'square Img'}
                          errorPlaceholder={PortraitDummyImg}
                          onClickRedirect={() => handleContentClick(item?.content_id)}
                        />
                        <div style={{ width: '73%' }} className="h-full">
                          <p
                            style={{
                              lineHeight: 'normal',
                              color: getStyleValue('content_section', 'content_title', '#ffffff'),
                            }}
                            className="cursor-pointer font-semibold xl:text-2xl md:text-xl text-xs line-clamp-1 w-fit mb-0"
                            onClick={() => handleContentClick(item?.content_id)}
                          >
                            {item.title}
                          </p>
                          <p
                            style={{
                              color: getStyleValue('content_section', 'content_title', '#ffffff'),
                            }}
                            className="mb-0 text-[10px] md:text-base xl:text-lg  mt-[8px] line-clamp-1"
                          >
                            {item.video_type}
                          </p>
                          <p
                            style={{
                              color: getStyleValue(
                                'content_section',
                                'content_description',
                                '#b2b2b2',
                              ),
                            }}
                            className="mb-0 text-[10px] md:text-sm xl:text-base  mt-[4px]  xl:mt-6 2xl:mt-[33px] "
                          >
                            <span className="italic">
                              Run Time : {convertDuration(item?.duration_in_s)}{' '}
                            </span>{' '}
                            |{' '}
                            <span className="italic">
                              Date Published : {getReleaseDate(item.publish_time)}
                            </span>
                          </p>
                          <p
                            style={{
                              color: getStyleValue(
                                'content_section',
                                'content_description',
                                '#b2b2b2',
                              ),
                            }}
                            className="mb-0 text-[10px] md:text-sm xl:text-base  mt-[8px] 
                           xl:mt-6 2xl:mt-[33px] line-clamp-4 "
                          >
                            {item?.description}
                          </p>
                          <div className="flex mt-[4px] xl:mt-6 2xl:mt-10">
                            {item?.category
                              .filter((e, i) => i < 4)
                              .map((info, idx) => (
                                <p
                                  style={{
                                    background: getStyleValue(
                                      'content_section',
                                      'category_bg_color',
                                      '#d6ff05',
                                    ),
                                    color: getStyleValue(
                                      'content_section',
                                      'category_color',
                                      '#010101',
                                    ),
                                    marginLeft: idx ? '0.625vw' : '',
                                  }}
                                  className={` text-[8px] font-semibold md:text-xs xl:text-sm line-clamp-1 w-fit mb-0 px-1 xl:px-3 xl:py-1 cursor-pointer`}
                                  key={idx}
                                  onClick={() => handleCategoryClick(info.id)}
                                >
                                  {info.name}
                                </p>
                              ))}
                          </div>
                        </div>
                      </div>
                    )
                  })
                : null}
            </div>
          </div>
          <div className="w-full xl:w-[29.239%] mt-4 xl:mt-0">
            {data?.ad_section1.image_s3key ? (
              <div className="mt-4 xl:mt-10 w-full cursor-pointer ">
                <CustomImage
                  imageUrl={getTemplateImage(data?.ad_section1?.image_s3key)}
                  imgClass="aspect-[500/678] w-full"
                  loaderClass="aspect-[500/678] w-full"
                  loaderStyle={{ background: '#5A5A5A50' }}
                  imgAlt={'square Img'}
                  errorPlaceholder={PortraitDummyImg}
                  onClickRedirect={() => handleRedirect(data.ad_section1.link)}
                />
              </div>
            ) : null}
            {data?.ad_section2.image_s3key ? (
              <div className="mt-4 xl:mt-10 w-full  cursor-pointer">
                <CustomImage
                  imageUrl={getTemplateImage(data?.ad_section2?.image_s3key)}
                  imgClass="aspect-[500/678] w-full"
                  loaderClass="aspect-[500/678] w-full"
                  loaderStyle={{ background: '#5A5A5A50' }}
                  imgAlt={'square Img'}
                  errorPlaceholder={PortraitDummyImg}
                  onClickRedirect={() => handleRedirect(data.ad_section2.link)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(SectionalWithAdSection)
